import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-84467460"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "container"
};
const _hoisted_2 = {
  class: "pb-40"
};
const _hoisted_3 = {
  class: "detail-title"
};
const _hoisted_4 = {
  class: "detail-content"
};
const _hoisted_5 = {
  class: "pb-80 animateFadeInUp"
};
const _hoisted_6 = {
  action: "https://formspree.io/f/xoqrzykl",
  method: "POST"
};
const _hoisted_7 = {
  class: "row"
};
const _hoisted_8 = {
  class: "col-12 col-md-6"
};
const _hoisted_9 = {
  class: "block-form__input"
};
const _hoisted_10 = {
  class: "label"
};
const _hoisted_11 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("input", {
  placeholder: "Full Name",
  type: "text",
  name: "fullname",
  required: "",
  value: ""
}, null, -1));
const _hoisted_12 = {
  class: "col-12 col-md-6"
};
const _hoisted_13 = {
  class: "block-form__input"
};
const _hoisted_14 = {
  class: "label"
};
const _hoisted_15 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("input", {
  placeholder: "Company",
  name: "company",
  required: "",
  value: ""
}, null, -1));
const _hoisted_16 = {
  class: "col-12 col-md-6"
};
const _hoisted_17 = {
  class: "block-form__input"
};
const _hoisted_18 = {
  class: "label"
};
const _hoisted_19 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("input", {
  placeholder: "Email Address",
  type: "email",
  name: "email",
  required: "",
  value: ""
}, null, -1));
const _hoisted_20 = {
  class: "col-12 col-md-6"
};
const _hoisted_21 = {
  class: "block-form__input"
};
const _hoisted_22 = {
  class: "label"
};
const _hoisted_23 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("input", {
  placeholder: "Subject",
  type: "text",
  name: "subject",
  required: "",
  value: ""
}, null, -1));
const _hoisted_24 = {
  class: "col-12"
};
const _hoisted_25 = {
  class: "block-form__textarea"
};
const _hoisted_26 = {
  class: "label"
};
const _hoisted_27 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("textarea", {
  name: "message",
  rows: "4",
  placeholder: "Start typing here…"
}, null, -1));
const _hoisted_28 = {
  class: "col-12 download-asset__button"
};
const _hoisted_29 = {
  type: "submit"
};
const _hoisted_30 = {
  class: "row pb-80 flex-start"
};
const _hoisted_31 = {
  class: "animateFadeInUp opacity-hide col-md-4 pr-40",
  style: {
    "animation-delay": "0.25s"
  }
};
const _hoisted_32 = {
  class: "contact-info-header"
};
const _hoisted_33 = {
  class: "scroll-block"
};
const _hoisted_34 = {
  class: "max-180"
};
const _hoisted_35 = {
  class: "animateFadeInUp opacity-hide col-md-4 pr-40",
  style: {
    "animation-delay": "0.5s"
  }
};
const _hoisted_36 = {
  class: "contact-info-header"
};
const _hoisted_37 = {
  class: "animateFadeInUp opacity-hide col-md-4 pr-40 contact-info",
  style: {
    "animation-delay": "0.75s"
  }
};
const _hoisted_38 = {
  class: "contact-info-header"
};
const _hoisted_39 = {
  href: "mailTo: nyoni@jlnyoni.com"
};
const _hoisted_40 = {
  href: "tel:+8618157898718"
};
const _hoisted_41 = {
  href: "tel:4008896590"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_createElementVNode("h1", _hoisted_3, _toDisplayString(_ctx.$t("contact.title")), 1), _createElementVNode("h1", _hoisted_4, _toDisplayString(_ctx.$t("contact.content")), 1)]), _createElementVNode("div", _hoisted_5, [_createElementVNode("form", _hoisted_6, [_createElementVNode("div", _hoisted_7, [_createElementVNode("div", _hoisted_8, [_createElementVNode("div", _hoisted_9, [_createElementVNode("label", null, [_createElementVNode("span", _hoisted_10, _toDisplayString(_ctx.$t("contact.fullName")), 1), _hoisted_11])])]), _createElementVNode("div", _hoisted_12, [_createElementVNode("div", _hoisted_13, [_createElementVNode("label", null, [_createElementVNode("span", _hoisted_14, _toDisplayString(_ctx.$t("contact.company")), 1), _hoisted_15])])]), _createElementVNode("div", _hoisted_16, [_createElementVNode("div", _hoisted_17, [_createElementVNode("label", null, [_createElementVNode("span", _hoisted_18, _toDisplayString(_ctx.$t("contact.emailAddress")), 1), _hoisted_19])])]), _createElementVNode("div", _hoisted_20, [_createElementVNode("div", _hoisted_21, [_createElementVNode("label", null, [_createElementVNode("span", _hoisted_22, _toDisplayString(_ctx.$t("contact.subject")), 1), _hoisted_23])])]), _createElementVNode("div", _hoisted_24, [_createElementVNode("div", _hoisted_25, [_createElementVNode("span", _hoisted_26, _toDisplayString(_ctx.$t("contact.message")), 1), _hoisted_27])]), _createElementVNode("div", _hoisted_28, [_createElementVNode("button", _hoisted_29, _toDisplayString(_ctx.$t("contact.submit")), 1)])])])]), _createElementVNode("div", _hoisted_30, [_createElementVNode("div", _hoisted_31, [_createElementVNode("h4", _hoisted_32, _toDisplayString(_ctx.$t("contact.address")), 1), _createElementVNode("div", _hoisted_33, [_createElementVNode("p", _hoisted_34, _toDisplayString(_ctx.$t("contact.factoryAdd")), 1)])]), _createElementVNode("div", _hoisted_35, [_createElementVNode("h4", _hoisted_36, _toDisplayString(_ctx.$t("contact.time")), 1), _createElementVNode("p", null, _toDisplayString(_ctx.$t("contact.weekDay")), 1), _createElementVNode("p", null, _toDisplayString(_ctx.$t("contact.weekTime")), 1)]), _createElementVNode("div", _hoisted_37, [_createElementVNode("h4", _hoisted_38, _toDisplayString(_ctx.$t("contact.contact")), 1), _createElementVNode("a", _hoisted_39, _toDisplayString(_ctx.$t("common.footer.contact.email")) + ": nyoni@jlnyoni.com", 1), _createElementVNode("a", _hoisted_40, _toDisplayString(_ctx.$t("common.footer.contact.phone")) + ": +86 18157898718", 1), _createElementVNode("a", _hoisted_41, _toDisplayString(_ctx.$t("common.footer.contact.landline")) + ": 400-8896-590", 1)])])]);
}